<template>
  <Detail :businessInfo="businessInfo" />
</template>
<script>
import Detail from "../detail.vue";
import { softwareByProductApi } from "@/api/website.js";
import { prefix } from "@/utils/env";
export default {
  name: "digital-airoad",
  components: {
    Detail,
  },
  data() {
    return {
      businessInfo: {
        name: "AIRoad",
        icon: require("@/assets/images/digitalImg/airoad_icon.png"),
        bgImg: require("@/assets/images/digitalImg/airoad_bg.png"),
        banner: {
          icon: require("@/assets/images/digitalImg/airoad_icon.png"),
          title: "AIRoad : 投标效率翻倍，方案成本减半",
          subTitle: "道路工程快速方案设计师",
          downloadBtnList: [
            {
              label: "下载客户端",
              otherLabel: "下载免费试用版",
              fileUrl: "",
              fileName: "AIRoad",
            },
          ],
          posterImg: require("@/assets/images/digitalImg/video_airoad.png"),
          videoUrl: `${prefix}/static/video/airoad2026_cn.mp4`,
        },
        all: {
          title: "什么是AIRoad？",
          content:
            "AIRoad依托自主研发的BIM引擎，基于GIS、航测遥感等数据构建数字化地形，快速实现方案参数化和智能化设计。通过动态交互式布线，自动构建方案模型。持续挖掘AI大语言模型和内容生成技术，在创意方案、效果表达和辅助成图等应用场景，提升设计效率。能够提升方案设计效率8～10倍，提升方案设计综合效率20～30%。",
          imgLists: [
            {
              id: 1,
              title: "对称双环式苜蓿叶形互通式立体交叉（1/3）",
              img: require("@/assets/images/digitalImg/airoad_img1.png"),
            },
            {
              id: 2,
              title: "对角象限双环式苜蓿叶形互通式立体交叉（2/3）",
              img: require("@/assets/images/digitalImg/airoad_img2.png"),
            },
            {
              id: 3,
              title: "A型三岔喇叭形互通式立体交叉（3/3）",
              img: require("@/assets/images/digitalImg/airoad_img3.png"),
            },
          ],
        },
        highlights: {
          title: "为什么选择AIRoad？",
          lists: [
            {
              id: 1,
              icon: require("@/assets/images/digitalImg/airoad_icon1.png"),
              title: "方案布设快速",
              content:
                "通过简单的参数输入实现自动布局，设计者可以用鼠标点击和拖动，可以快速编辑和修改相关内容，实现一键操作。",
            },
            {
              id: 2,
              icon: require("@/assets/images/digitalImg/airoad_icon2.png"),
              title: "多专业协同",
              content:
                "软件包含互通式立交设计、桥梁设计、隧道设计、交叉口设计等多专业。",
            },
          ],
        },

        function: {
          title: "AIRoad的功能！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/function01.png"),
              title: "基于三维场景设计",
              content:
                "系统支持项目卫片、地形图及其他控制因素的统筹管理，包括地形、地物数据的导入与导出。基于三维场景进行设计，自动创建道路三维模型，满足工可及方案研究阶段设计输入的要求，建模速度提升10倍以上，综合设计效率提升30%。",
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/function02.png"),
              title: "快速完成立交枢纽方案设计",
              content:
                "沿用 EICAD 模式法的设计思路，同时拥有自动布线、自动拉坡及立交连接部自动设计的功能，能快速实现立交方案设计，并支持动态拖动、双击修改，交互直观、便捷。",
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/function03.png"),
              title: "实体之间实时联动，多专业快速设计",
              content: [
                "在桥梁设计中，上、下部结构采用参数化设计理念，指定构件及起终点，自动创建桥梁模型，通过桥梁与道路模型中路面、路基、边坡的连接技术，实现桥梁、道路及数模等各专业的协同设计。",
                "在隧道设计中，可快速创建出隧道模型，结合地质纵断确定隧道起终点桩号，快速完成纵向设计，支持方案的快速调整。隧道洞口的设计，采用数据输入和图形交互相结合的方式，所见即所得。",
                "在交叉口路网设计，软件支持路网平交口实体一键生成，自动更新道路模型后就可生成所有平交口模型，极大提升了效率。",
              ],
            },
          ],
        },
        support: {
          title: "AIRoad 的用户支持 ",
          // documnentUrl: "/download?anchor=manual",
          documnentUrl: "/dnnweb/helpDocuments?soft=AIRoad&language=zh",
          videosUrl: "/academy?anchor=AIRoad",
        },
        contact: {
          bgImg: require("@/assets/images/digitalImg/airoad_contactbg.png"),
          title: "立即获取AIRoad！",
          subTitle: "狄诺尼数字设计软件产品线，为您带来一站式设计解决方案",
          downLoadBtnText: "下载产品手册",
          downLoadBtnUrl: "/download?anchor=manual",
          contactBtnText: "让销售人员联系您",
          contactBtnUrl: "",
        },
        combination: {
          title: "使用其他软件配合 AIRoad 进行工作！",
          lists: [
            {
              id: 1,
              img: require("@/assets/images/digitalImg/airoad_combination01.png"),
              title: "使用AIRoad",
              subTitle: "完成“新扬高速公路宿迁枢纽至黄花塘枢纽段扩建工程”",
              content: "- 项目使用AIRoad实现路线设计，并进行方案工可汇报",
              caseUrl: "",
            },
            {
              id: 2,
              img: require("@/assets/images/digitalImg/airoad_combination02.png"),
              title: "使用AIRoad",
              subTitle: "完成“沈海线漳州龙海至诏安段扩容工程-盘陀互通”",
              content: "- 项目使用AIRoad实现路线设计，并进行方案工可汇报",
              caseUrl: "",
            },
            {
              id: 3,
              img: require("@/assets/images/digitalImg/airoad_combination03.png"),
              title: "使用AIRoad",
              subTitle: "完成“沈阳都市圈环线高速公路依路枢纽”",
              content: "- 项目使用AIRoad实现路线设计，并进行方案工可汇报",
              caseUrl: "",
            },
          ],
          softwares: [
            {
              name: "EICAD",
              icon: require("@/assets/images/digitalImg/eicad_icon2.png"),
              desc: "一款含有外业调查、数字地面模型、路线、互通立交、路基路面、桥涵、隧道、交通工程、给排水等多个专业模块的数字化设计软件全家桶。",
            },
          ],
        },
      },
    };
  },
  created() {
    this.getSoftware();
  },
  methods: {
    async getSoftware() {
      await softwareByProductApi({ productId: "1" }).then((res) => {
        if (res.code === 200) {
          if (res.data.length > 0 && res.data[0].pathUrlIdList.length > 0) {
            this.businessInfo.banner.downloadBtnList[0].fileUrl =
              res.data[0].pathUrlIdList[0].path;
            this.businessInfo.banner.downloadBtnList[0].fileName =
              res.data[0].pathUrlIdList[0].fileTitle;
          } else {
            this.businessInfo.banner.downloadBtnList[0].fileUrl = "";
            this.businessInfo.banner.downloadBtnList[0].fileName = "";
          }
        }
      });
    },
  },
};
</script>
